export default __webpack_public_path__ + "static/media/ic_page.f57703b1.svg";